module.exports = __webpack_public_path__ + "static/media/clutchLogin.9f877097.webp";